import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table, Button, Modal } from "react-bootstrap";
import { MdOutlineArrowBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import EditModal from "./editModal";
import { useSearchParams  } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../utils/constants";

export default function CandidatesIndex() {
    const navigate = useNavigate();
    
    const [searchParams] = useSearchParams();
    const cardId = searchParams.get("cardId");

    const [showEditModal, setShowEditModal] = useState(false);
    const [courseData, setCourseData] = useState(null);
    const [courses, setCourses] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState("");
    const [categories, setCategories] = useState([]);

    const handleEdit = (course) => {
        setShowEditModal(!showEditModal)
        setCourseData(course);
    }

    const getEducationCourses = async (cardId) => {
        try {
            const response = await axios.get(`${API_URL}/educationCourses?cardId=${cardId}`);
            setCourses(response.data.result);
            const allCategories = [...new Set(response.data.result.map(course => course.categoryName))];
            setCategories(allCategories);
        } catch (error) {
            console.error("Error updating course:", error);
            // Optionally show an error message to the user
        }

    }


    useEffect(() => {
        getEducationCourses(cardId);
    }, [cardId]);

    return (
        <>
        <Container className="component-container">
                <div className="list-component-main-div">
                    <div className="home-menu-main-div component-heading-main-div">
                        <div className="list-heading-div">
                            <div className="list-title">COURSES APP LINKS</div>
                            <div className="list-title-line" />
                        </div>
                        <div className="home-menu-btn align-items-center">
                            <div className="home-menu-btn add-btn-div-cls">
                            {/* <Button className="menu-btn-cls" onClick={() => navigate('/add-user')}>Export</Button> */}
                            </div>
                            <div className="back-btn-div-cls">
                                <Button className="back-btn-cls" onClick={() => navigate('/home')}><MdOutlineArrowBack /> BACK</Button>
                            </div>
                        </div>
                    </div>

                    <Row>
                        <Col>
                            <div className="list-title mb-3" style={{ maxWidth: "300px" }}>
                                <label className="mb-1">Filter by Department:</label>
                                <select
                                    className="form-control"
                                    value={selectedCategory}
                                    onChange={(e) => setSelectedCategory(e.target.value)}
                                >
                                    <option value="">All departments</option>
                                    {categories.map((cat, idx) => (
                                        <option key={idx} value={cat}>{cat}</option>
                                    ))}
                                </select>
                            </div>
                        <div className="list-component-main-div">
                            <Table responsive className="list-table-cls">
                                <thead className="list-thead-cls">
                                    <tr className="list-thead-tr">
                                        <th>Course Name</th>
                                        <th>Department</th>
                                        <th>Level</th>
                                        {/* <th>Enum</th> */}
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { (selectedCategory ? courses.filter(course => course.categoryName === selectedCategory) : courses).map( (course) => (
                                        <tr key={`courseId-${course.id}`}>
                                            <td>{course.courseName}</td>
                                            <td>{course.categoryName}</td>
                                            <td>{course.levelName}</td>
                                            {/* <td>{course.enumCode}</td> */}
                                            <td>{course.published.toString() == true.toString() ? 'Active' : 'Inactive'}</td>
                                            <td>
                                                <button className="btn btn-primary" onClick={ () => handleEdit(course) }>Edit</button>
                                            </td>
                                        </tr>
                                    ) ) }
                                </tbody>
                            </Table>
                        </div>
                        </Col>
                    </Row>
                </div>
        </Container>
        
        <EditModal showEditModal={showEditModal} setShowEditModal={setShowEditModal} courseData={courseData}/>
        </>
    )
};